var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.body] = true, _obj[_vm.$style.sunken] = _vm.sunken, _obj )},[(_vm.$slots.description)?_c('p',{class:_vm.$style.description},[_vm._t("description")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }